import { useEffect, useState } from "react";

const formatSlug = (text) => {
  return text?.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, '');
};


const generateXML = (matchingProducts, statesCitiesData) => {
  let xmlContent = '<?xml version="1.0" encoding="UTF-8"?>\n';
  xmlContent += '<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n';

  let allUrls = [];

  matchingProducts?.forEach((product) => {
    const productSlug = formatSlug(product.name);

    statesCitiesData?.forEach((stateItem) => {
      const stateSlug = formatSlug(stateItem.state);

      // URL for product in the state
      allUrls.push(`https://www.vanshikaplastic.com/page/seo/${productSlug}-in-${stateSlug}`);

      // For each city in the state
      stateItem.cities?.forEach((city) => {
        const citySlug = formatSlug(city);
        
        // URL for product in the city
        allUrls.push(`https://www.vanshikaplastic.com/page/seo/${productSlug}-in-${citySlug}`);
      });
    });
  });

  // Function to chunk the URLs into groups of 400
  const chunkUrls = (urls, chunkSize) => {
    let chunks = [];
    for (let i = 0; i < urls.length; i += chunkSize) {
      chunks.push(urls.slice(i, i + chunkSize));
    }
    return chunks;
  };

  // Chunk the URLs into groups of 400
  const urlChunks = chunkUrls(allUrls, 50000);
  const totalPages = urlChunks.length;

  // For each chunk, generate a sitemap entry
  for (let i = 0; i < totalPages; i++) {
    const sitemapFileName = `sitemap${i + 1}.xml`;

    // Adding the URLs for the current chunk into the sitemap
    xmlContent += `  <sitemap>\n`;
    xmlContent += `    <loc>https://www.vanshikaplastic.com/page/seo/sitemap/${sitemapFileName}</loc>\n`;
    xmlContent += `    <lastmod>2025-05-08</lastmod>\n`;
    xmlContent += `  </sitemap>\n`;

    // Add individual product state and city URLs in the sitemap entries
    urlChunks[i].forEach((url) => {
      xmlContent += `  <url>\n`;
      xmlContent += `    <loc>${url}</loc>\n`;
      xmlContent += `    <lastmod>2025-05-08</lastmod>\n`;
      xmlContent += `  </url>\n`;
    });
  }

  xmlContent += '</urlset>\n';
  return xmlContent;
};

const XMLUrlList = ({ matchingProducts, statesCitiesData }) => {
  const [xmlData, setXmlData] = useState("");

  useEffect(() => {
    if (matchingProducts && statesCitiesData) {
      const xmlContent = generateXML(matchingProducts, statesCitiesData);
      setXmlData(xmlContent);
    }
  }, [matchingProducts, statesCitiesData]);

  return (
    <div className="container py-4">
      <pre>{xmlData}</pre>
    </div>
  );
};

export default XMLUrlList;
